import { mezoMainnet, mezoTestnet } from "@mezo-org/orangekit";
export { mezoMainnet, mezoTestnet } from "@mezo-org/orangekit";
export const CHAIN_ID = {
    testnet: mezoTestnet.id,
    mainnet: mezoMainnet.id,
};
export const RPC_BY_NETWORK = {
    mainnet: {
        http: mezoMainnet.rpcUrls.default.http[0],
        webSocket: mezoMainnet.rpcUrls.default.webSocket?.[0],
    },
    testnet: {
        http: mezoTestnet.rpcUrls.default.http[0],
        webSocket: mezoTestnet.rpcUrls.default.webSocket?.[0],
    },
};
//# sourceMappingURL=constants.js.map